
// ** 기본호출 **
// layer.openFn({ 'target' : '클래스명' });
// ** ajax 호출 **
// layer.openFn({ 'ajaxUrl' : 'url주소' });
// ** 닫기 **
// layer.closeFn( Call Back Function);

document.addEventListener('DOMContentLoaded' , () =>{
    const layer = (function(){
        const defaultOption = {
            target : '.layer',
            $target : document.querySelector('.layer'),
            ajaxUrl : undefined,
            ajaxCall : false,
            prevTarget : undefined,
            active : false
        }
        const bodyEl = document.querySelector('body');
        let option = {};
    
        const openFn = (newOption) => {
            if(option.prevTarget != undefined){
                closeFn( function(){
                    _openFn(newOption);
                });
            }else{
                _openFn(newOption);
            }
    
        }
    
        const closeFn = (callBackFn = undefined) => {
            if(option.active){
                if( option.prevTarget == undefined ){
                    option.prevTarget = option.$target;
                }
                
                if( option.ajaxCall ){
                    option.prevTarget.parentNode.remove();
                    option.ajaxUrl = undefined;
                    option.ajaxCall = false;
                }else{
                    option.$target.style.display = 'none';
                }
    
                bodyEl.classList.remove('ovf');
                option.prevTarget = undefined;
                option.active = false;
                option = defaultOption;
    
                if( callBackFn !== undefined ){
                    callBackFn();
                }
            }
        }
        const ajaxCheck = () => {
            if( option.ajaxUrl != undefined ){
                fetch(option.ajaxUrl)
                    .then( response => {
                        // console.log(response);
                        if (response.ok) {
                            return response.text();
                        } else {
                            alert('네트워크 오류');
                        }
                    })
                    .then( html => {
                        let dom = document.createElement('div');
                        dom.innerHTML = html;
                        option.$target = dom.querySelector('.layer');

                        document.querySelector('.content').appendChild(dom);
                        
                        _showFn();
                        
                        option.ajaxCall = true;
                    })
                    .catch(function (err) {
                        alert(err)
                    });
            }else{
                _showFn();
            }
        }
    
        const _openFn = (newOption) => {
            option = Object.assign(defaultOption, newOption);
            option.$target = document.querySelector(option.target);
            
            ajaxCheck();
        }

        const _showFn = () => {
            option.$target.style.display = 'block';
            bodyEl.classList.add('ovf');
    
            option.prevTarget = option.$target;
            option.active = true;
    
            let closeBtn = option.$target.querySelectorAll('.close');
    
            closeBtn.forEach(function(el){
                el.addEventListener('click' , function(){
                    closeFn();
                });
            });
        }
    
        const applyFn = () => {
            option = defaultOption;
    
            document.querySelectorAll('.layer_btn').forEach(el => {
                el.addEventListener('click' , function(){
                    const layerName = el.getAttribute('data-layer');
                    if(document.querySelector('.'+layerName)){
                        _openFn({ 'target' : '.'+layerName });
                    }else{
                        alert('호출에 문제가 생겼습니다. [ 해당 레이어 없음 ]');
                    }
                });
            });
        }
    
        return {
            applyFn : applyFn,
            openFn : openFn,
            closeFn : closeFn
        }
    })();

    window.layer = layer;
    window.layer.applyFn();
});
